<template>
  <div class="page no-company">
    <div><h5>{{ printLang('MyAccount.NoCompany.NoAttachedCompany') }}</h5></div>
    <div v-if="companyInvites" style="font-weight:bold">{{ printLang('MyAccount.NoCompany.JoinInvites') }}</div>
    <div v-for="invite in invites" :key="invite.id">{{ invite.company_name }} - <a href="#" @click="joinCompany(invite.company_id)">{{ printLang('MyAccount.NoCompany.Join') }}</a></div>
    <div style="margin-top:30px">
      <a :href="`${baseUrl}#premium`"><div style="font-weight:bold">{{ printLang('MyAccount.NoCompany.OrCreateNew') }}</div></a>
    </div>
  </div>
</template>

<script>
  import { printLang } from './lang';
  import apiSrv from './apiSrv';

  export default {
    data() {
      return {
        printLang,
        companyInvites: null,
        invites: [],
      };
    },
    computed: {
      baseUrl() { return printLang('Url'); },
    },
    mounted() {
      apiSrv.getApi(window.api.companyinvites.url, (data) => {
        const { invites } = data;
        if (invites && invites.length) {
          this.companyInvites = true;
          this.invites = data.invites;
        }
      });
    },
    methods: {
      joinCompany(id) {
        apiSrv.getApi(`${window.api.companyinvites.url}/accept/${id}`, () => {
          this.$emit('show-page', 'company');
        });
      },
    },
  };
</script>
